import React, { Component } from 'react';
import axios from 'axios'; // Importa Axios
import SearchInput from './SearchInput';
import SpotifyWebApi from 'spotify-web-api-js';
import './styles.css';
import nophoto from '../notfound-modified.png'

class TableResult extends Component {

  state = {loaded: false,
          selectedID: null,
          selectedImg: "",
          selectedName: ""};


  getArtistAlbumsRecursive = (id, name , img , offset = 0, allAlbums = [], side = this.props.side, type = "album") => {

    const spotify = new SpotifyWebApi();

    if(spotify.getAccessToken() == null){
      
      const authOptions = {
        url: 'https://accounts.spotify.com/api/token',
        headers: {
          Authorization: `Basic ${btoa(SearchInput.CLIENT_ID + ':' + SearchInput.CLIENT_SECRET)}`,
        },
        data: 'grant_type=client_credentials',
      };
    
      axios
        .post(authOptions.url, authOptions.data, { headers: authOptions.headers })
        .then((response) => {
          const token = response.data.access_token;
          //const spotify = new SpotifyWebApi();
          spotify.setAccessToken(token);
          console.log("settato token")
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      const limit = 50


        this.props.onSetLoading(this.props.side, true)
        this.setState({selectedID: "loading"})
    
      spotify.getArtistAlbums(id, { limit, offset, include_groups: type })
      .then((data) => {
        const albums = data.items.filter((album) => album.album_type !== "compilation");
        console.log("new check", albums, " ", type)
        allAlbums.push(...albums);

        // Cicla tra "album", "single" e "appears_on"
        const nextTypes = ["album", "single", "appears_on"];
        const nextTypeIndex = nextTypes.indexOf(type);
        if(albums.length == limit){
          this.getArtistAlbumsRecursive(id,name , img ,offset+limit, allAlbums, side, type);
        } else if(nextTypeIndex !== -1 && nextTypeIndex < nextTypes.length - 1) {
          // Passa alla prossima categoria
          const nextType = nextTypes[nextTypeIndex + 1];
          this.getArtistAlbumsRecursive(id,name , img ,offset, allAlbums, side, nextType);
        } else {
          // Quando hai terminato tutte le categorie, stampa l'elenco completo
          this.props.onSetArtist(allAlbums, side, id, name, img);
          this.setState({selectedID: id})
          this.props.onSetLoading(this.props.side, false)
          //console.log('Elenco completo degli album:', allAlbums, side);
        }
      })
      .catch((err) => {
        if(err.status == 429){
          alert("Server overload, sorry for the inconvenience")
          this.setState({selectedID: "loading"})
        }
      });

      

    }
  }
  

  componentDidMount() {
    this.state.selectedID = null
    this.animateComponent();
  }

  componentWillUnmount() {
    this.state.selectedID = null
    //this.removeAnimation();
    
  }

  animateComponent() {
    this.component.classList.add('animate'); // Add the CSS class for animation
  }

  removeAnimation() {
    this.component.classList.remove('animate'); // Remove the CSS class to reset the animation
  }

 

  render() {
    const { results } = this.props; 
    const { selectedID } = this.state;
    //console.log(side)
    if(selectedID == null){
      return (
        <div className="fadein" ref={(component) => (this.component = component)}>
        <table className="table table-dark table-hover" style={{ cursor: 'pointer', borderColor: "#D9E724", textAlign: "center", verticalAlign: "middle", color: "white"}}>
          <thead style={{borderColor: '#8b008b', backgroundColor: "#535353"}}>
            <tr>
              <th scope="col"></th>
              <th scope="col">Name</th>
              <th scope="col">Genre</th>
            </tr>
          </thead>
          <tbody>
            {results.map((result, index) => (
              <tr key={result.id} onClick={() => { this.getArtistAlbumsRecursive(result.id, result.name, result.images[0]?.url || nophoto, 0);}}>
                <td>
                {result.images.length > 0 ? (
                      <img
                          src={result.images[0].url}
                          alt={result.name}
                          style={{ width: '50px', height: '50px' }} // Imposta la larghezza desiderata in pixel
                      />
                      ) : (
                        <img
                        src={nophoto}
                        alt={"Photo unavailable"}
                        style={{ width: '50x', height: '50px' }} // Imposta la larghezza desiderata in pixel
                    />
                      )}
                </td>
                <td>{result.name}</td>
                <td>{result.genres[0] ? ( 
                      result.genres[0] 
          ) : (
            "Unknown"
          )}</td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      );
    }else if(this.state.selectedID == "loading"){

    }
    
  }
}

export default TableResult;
